class Navigation extends HTMLElement {
  constructor() {
    super();

    // update time every second
    this.updateTime = this.updateTime.bind(this);
    this.updateTime();
    setInterval(this.updateTime, 1000);

    this.cartLink = this.querySelectorAll('.navigation-menu-item--cart a');

    if (this.cartLink.length > 0) {
      this.cartLink.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('toggle-cart'));
        });
      });
    }

    // listen to inventory-update
    document.addEventListener('inventory-updated', (e) => {
      const { item_count } = e.detail;

      console.log(e.detail);
      this.updateInventory(item_count);
    });

    this.hamburger = this.querySelector('.navigation-hamburger');
    if (this.hamburger) {
      this.hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleMenu();
      });
    }
  }

  toggleMenu() {
    const menu = this.querySelector('.navigation-menu');
    if (!menu) return;

    if (this.dataset.open === 'true') {
      this.dataset.open = false;
      menu.classList.remove('open');
    } else {
      this.dataset.open = true;
      menu.classList.add('open');
    }
  }

  updateInventory(inventory) {
    const inventoryElement = this.querySelectorAll('.navigation-menu-item--cart a span');
    if (!inventoryElement) return;

    if (inventoryElement.length === 0) return;
    if (inventoryElement.length > 1) {
      inventoryElement.forEach((element) => {
        if (!inventory) {
          inventoryElement.textContent = '';
          return;
        }
        element.textContent = inventory;
      });
      return;
    }
  }

  updateTime() {
    const element = this.querySelector('.navigation-time');
    if (!element) return;
    const time = new Date();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    element.textContent = formattedTime;
  }
}

customElements.define('section-navigation', Navigation);
